const CDN = `https://assets.standardresume.co/raw/upload/fonts/lora`;

export default function LoraFont() {
  return (
    <style>{`
        @font-face {
          font-family: 'Lora';
          font-style:  normal;
          font-weight: 400;
          font-display: swap;
          src: url('${CDN}/latin-regular.woff2') format("woff2"),
            url('${CDN}/latin-regular.woff') format("woff");
        }
        @font-face {
          font-family: 'Lora';
          font-style:  italic;
          font-weight: 400;
          font-display: swap;
          src: url('${CDN}/latin-regular-italic.woff2') format("woff2"),
            url('${CDN}/latin-regular-italic.woff') format("woff");
        }
        @font-face {
          font-family: 'Lora';
          font-style:  normal;
          font-weight: 700;
          font-display: swap;
          src: url('${CDN}/latin-bold.woff2') format("woff2"),
            url('${CDN}/latin-bold.woff') format("woff");
        }
        @font-face {
          font-family: 'Lora';
          font-style:  italic;
          font-weight: 700;
          font-display: swap;
          src: url('${CDN}/latin-bold-italic.woff2') format("woff2"),
            url('${CDN}/latin-bold-italic.woff') format("woff");
        }
      `}</style>
  );
}
